import React from 'react';
import { ShieldAlert, ToggleLeft } from 'lucide-react';
import { useApp } from '../../context/AppContext';

export const FusesBreakers: React.FC = () => {
  const { equipmentItems } = useApp();

  const fuseItems = equipmentItems.filter((item) => {
    const type = (item['Type'] || '').toUpperCase();
    return type === 'FUSIBLE' || type === 'FUSED' || type === 'FUSE';
  });

  const breakerItems = equipmentItems.filter((item) => {
    const type = (item['Type'] || '').toUpperCase();
    return type === 'BREAKER';
  });

  if (fuseItems.length === 0 && breakerItems.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: '24px' }}>
      {fuseItems.length > 0 && (
        <>
          <h2 className="section-title">
            <ShieldAlert className="h-5 w-5 text-amber-500" />
            <span>Fuses</span>
          </h2>
          <div className="fuse-breaker-grid">
            {fuseItems.map((item, idx) => (
              <div key={idx} className="fuse-breaker-card">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '36px',
                    height: '36px',
                    background: 'rgba(245, 127, 23, 0.1)',
                    color: 'var(--primary)',
                    borderRadius: '8px',
                    flexShrink: 0,
                  }}
                >
                  <ShieldAlert className="h-5 w-5" />
                </div>
                <div>
                  <h4 style={{ margin: 0, fontSize: '0.95rem', fontWeight: 600 }}>
                    {item['Equipment'] || 'Fuse'}
                  </h4>
                  <p style={{ margin: '2px 0 0 0', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                    {item['Description'] || 'No Details'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {breakerItems.length > 0 && (
        <>
          <h2 className="section-title">
            <ToggleLeft className="h-5 w-5 text-amber-500" />
            <span>Breakers</span>
          </h2>
          <div className="fuse-breaker-grid">
            {breakerItems.map((item, idx) => (
              <div key={idx} className="fuse-breaker-card">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '36px',
                    height: '36px',
                    background: 'rgba(245, 127, 23, 0.1)',
                    color: 'var(--primary)',
                    borderRadius: '8px',
                    flexShrink: 0,
                  }}
                >
                  <ToggleLeft className="h-5 w-5" />
                </div>
                <div>
                  <h4 style={{ margin: 0, fontSize: '0.95rem', fontWeight: 600 }}>
                    {item['Equipment'] || 'Breaker'}
                  </h4>
                  <p style={{ margin: '2px 0 0 0', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                    {item['Description'] || 'No Details'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
